import { useTheme } from '@pata-app/themes';

import React, { memo, useRef, useState } from 'react';

import { NewIcon } from '../../../../../components/newIcon/icon';
import { AnswerContainer, FaqContainer, QuestionContainer } from './faq.styled';

interface IFaq {
  question: string;
  answer: string;
}

const Faq = ({ question, answer: Answer }: IFaq) => {
  const theme = useTheme();

  const answerRef = useRef<null | HTMLDivElement>();

  const answerHeight = answerRef?.current?.scrollHeight;

  const [showAnswer, setShowAnswer] = useState(false);

  const handleFaqClick = () => {
    setShowAnswer(!showAnswer);
  };

  return (
    <FaqContainer>
      <QuestionContainer onClick={handleFaqClick} showAnswer={showAnswer}>
        {question}
        <NewIcon type="Arrow" fill={theme.core.colors.primary.green.medium} />
      </QuestionContainer>
      <AnswerContainer ref={answerRef} showAnswer={showAnswer} maxHeight={answerHeight}>
        <Answer />
      </AnswerContainer>
    </FaqContainer>
  );
};

export default memo(Faq);
